module.exports = __webpack_public_path__ + "static/media/header_left.39990ffa.svg";